import * as React from "react";

import { useEffect, useState } from "react";
import HeaderLayoutDefault from "./Layouts/HeaderLayoutDefault";
import HeaderLayoutLeft from "./Layouts/HeaderLayoutLeft";
import HeaderLayoutCenter from "./Layouts/HeaderLayoutCenter";
import HeaderLayoutRight from "./Layouts/HeaderLayoutRight";
import HeaderSplit2RowLeft from "./Layouts/HeaderSplit2RowLeft";
import './Header.scss';

const Layouts = {
    'header-layout-left': HeaderLayoutLeft,
    'header-split-2row-left': HeaderSplit2RowLeft,
    'header-layout-center': HeaderLayoutCenter,
    'header-layout-right': HeaderLayoutRight,
}

export const Header = ({ colorSchema, links, item_count = '', settings, type = 'left', show_search_bar = false }) => {
    const LayoutComponent = Layouts[type] || HeaderLayoutDefault;
    const [isTransparent, setIsTransparent] = useState(settings.section?.transparent_on_top || false);
    const [isProcessingDiscount, setIsProcessingDiscount] = useState(false);

    // Set CSS variables for the header
    const headerStyles = {
        '--cart-counter-radius': `${settings.section?.cart_counter_radius || 12}px`,
        '--cart-counter-bg-color': settings.section?.cart_counter_bg_color || '#000',
        '--cart-counter-text-color': settings.section?.cart_counter_text_color || '#fff',
        '--header-actions-spacing': `${settings.section?.header_actions_spacing || 24}px`,
        '--menu-logo-spacing': `${settings.section?.menu_logo_spacing || 20}px`,
        '--mobile-icon-size': `${settings.section?.mobile_icon_size || 24}px`,
        '--mobile-logo-size': `${settings.section?.mobile_logo_size || 107}px`,
        '--mobile-min-height': `${settings.section?.mobile_min_height || 64}px`,
        '--desktop-min-height': `${settings.section?.desktop_min_height || 0}px`
    } as React.CSSProperties;

    // Handle scroll effects
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const discountTitle = urlParams.get('discount-title');
        
        if (discountTitle) {
            setIsProcessingDiscount(true);
            document.body.style.visibility = 'hidden';
            document.body.style.backgroundColor = 'white';
            const mainContent = document.querySelector('main');
            if (mainContent) {
                mainContent.style.display = 'none';
            }
        }

        const headerContainer = document.querySelector('.header-container');
        const handleScroll = () => {
            const isScrolled = window.scrollY > 20;
            const action = isScrolled ? 'remove' : 'add';

            // Update transparency based on scroll position
            if (settings.section?.transparent_on_top) {
                setIsTransparent(!isScrolled);
                headerContainer?.classList[action]('transparent-bg');
                document.body.classList[action]('transparent-on-top');
            }

            if (settings.section?.invert_colors_when_transparent) {
                headerContainer?.classList[action]('inverted-colors');
            }

            if (settings.section?.shadow_on_scroll) {
                const action = isScrolled ? 'add' : 'remove';
                headerContainer?.classList[action]('with-shadow');
            }
        };

        // Call once to initialize state based on current scroll position
        handleScroll();

        window.addEventListener('scroll', handleScroll);

        async function updateCartAttributes() {
            const urlParams = new URLSearchParams(window.location.search)
            const discountTitle = urlParams.get('discount-title');

            if (!discountTitle) return;

            setIsProcessingDiscount(true);

            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({
                        attributes: {
                            discount_code: discountTitle
                        }
                    })
                })
                    .then(res => res.json())
                    .then(() => {
                        urlParams.delete('discount-title');
                        const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                        window.history.replaceState({}, document.title, newUrl);
                        window.location.reload();
                
                    });
            } catch (error) {
                console.error('Failed to update cart attributes:', error);
                setIsProcessingDiscount(false);
            }
        }

        updateCartAttributes();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [settings.section?.transparent_on_top]);

    if (isProcessingDiscount) {
        return null;
    }

    return (
        <div
            x-init="$nextTick(() => { $store.navigation.init() })"
            style={headerStyles}
            data-transparent={isTransparent}
            className={'header-menu-container'}
        >
            <LayoutComponent
                settings={settings}
                links={links}
                item_count={item_count}
                show_search_bar={settings.section?.enable_searchbar || false}
            />
        </div>
    );
};

